module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="filter_button">\n	<span></span>\n</div>';

}
return __p
}